import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';
import { ClientAttachmentId } from 'owa-client-ids';
import { saveToCloudPostProcess } from 'owa-attachment-full-data/lib/actions/saveToCloud';
import AttachmentFullViewState from 'owa-attachment-full-data/lib/schema/AttachmentFullViewState';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import SaveToCloudNotificationPayload from 'owa-service/lib/contract/SaveToCloudNotificationPayload';

export function getSaveAllToCloudNotificationHandler(
    attachmentsToSaveToCloud: ClientAttachmentId[],
    operationStatus: { operationFailed: boolean; error: string },
    datapoint: PerformanceDatapoint,
    countOfAttachments: number,
    getAttachmentViewState: (clientAttachmentId: ClientAttachmentId) => AttachmentFullViewState,
    completeHandler: (operationFailed: boolean) => void,
    stopFakeProgressIndicator?: (attachmentId: ClientAttachmentId, succeeded: boolean) => void
) {
    return (payload: SaveToCloudNotificationPayload): boolean => {
        const attachmentId = payload.AttachmentId;
        let index = -1;
        const attachments: ClientAttachmentId[] = attachmentsToSaveToCloud.filter(
            (clientAttachmentId, attachmentIndex) => {
                if (clientAttachmentId.Id === attachmentId) {
                    index = attachmentIndex;
                    return true;
                }
                return false;
            }
        );

        if (attachments.length > 0) {
            attachmentsToSaveToCloud.splice(index, 1);
            const attachmentViewState = getAttachmentViewState(attachments[0]);
            const succeeded = payload.ResultCode === AttachmentResultCode.Success;
            saveToCloudPostProcess(
                attachmentViewState,
                succeeded,
                succeeded ? payload.Item.Location : null
            );
            if (stopFakeProgressIndicator) {
                stopFakeProgressIndicator(attachments[0], succeeded);
            }
            if (payload.ResultCode !== AttachmentResultCode.Success) {
                operationStatus.operationFailed = true;
                if (payload.Exception) {
                    operationStatus.error = payload.Exception;
                }
            }
        }

        if (attachmentsToSaveToCloud.length === 0) {
            completeHandler(operationStatus.operationFailed);
            datapoint.addCustomData([
                countOfAttachments,
                !operationStatus.operationFailed,
                payload.ResultCode,
            ]);
            if (operationStatus.error) {
                datapoint.endWithError(
                    DatapointStatus.ServerError,
                    new Error(operationStatus.error)
                );
            } else {
                datapoint.end();
            }

            return true;
        }

        return false;
    };
}

export function getSaveAllToCloudFailureHandler(
    attachmentsToSaveToCloud: ClientAttachmentId[],
    datapoint: PerformanceDatapoint,
    countOfAttachments: number,
    getAttachmentViewState: (clientAttachmentId: ClientAttachmentId) => AttachmentFullViewState,
    completeHandler: (operationFailed: boolean) => void,
    stopFakeProgressIndicator?: (attachmentId: ClientAttachmentId, succeeded: boolean) => void
) {
    return (
        error: string,
        resultCode: AttachmentResultCode,
        datapointStatus: DatapointStatus
    ): void => {
        attachmentsToSaveToCloud.forEach(attachmentId => {
            const attachmentViewState = getAttachmentViewState(attachmentId);
            saveToCloudPostProcess(attachmentViewState, false, null);
            if (stopFakeProgressIndicator) {
                stopFakeProgressIndicator(attachmentId, false);
            }
        });
        completeHandler(true);
        datapoint.addCustomData([countOfAttachments, false, resultCode]);
        datapoint.endWithError(datapointStatus, new Error(error));
    };
}
